import { render, staticRenderFns } from "./confirmTip.vue?vue&type=template&id=c8f4c36a&scoped=true&"
import script from "./confirmTip.vue?vue&type=script&lang=js&"
export * from "./confirmTip.vue?vue&type=script&lang=js&"
import style0 from "./confirmTip.vue?vue&type=style&index=0&id=c8f4c36a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f4c36a",
  null
  
)

export default component.exports